/* Dots + slide counter for the mobile product gallery.
   Reads scroll position off Dawn's existing gallery slider rather than
   owning the scrolling, so zoom, thumbnails and variant switching keep
   working untouched. */
class PbxGalleryNav extends HTMLElement {
  connectedCallback() {
    this.slider = document.getElementById(this.dataset.slider);
    if (!this.slider) return;

    this.dots = Array.from(this.querySelectorAll('.pbx-gallery-dot'));
    this.currentElement = this.querySelector('[data-pbx-current]');
    this.index = -1;
    this.onScroll = this.onScroll.bind(this);

    this.measure();
    this.resizeObserver = new ResizeObserver(() => this.measure());
    this.resizeObserver.observe(this.slider);
    this.slider.addEventListener('scroll', this.onScroll, { passive: true });
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index)));
    });
  }

  disconnectedCallback() {
    this.slider?.removeEventListener('scroll', this.onScroll);
    this.resizeObserver?.disconnect();
  }

  /* Slide geometry is only read here, never in the scroll handler, so
     scrolling stays free of forced layout. */
  measure() {
    const slides = Array.from(this.slider.querySelectorAll('[id^="Slide-"]')).filter((slide) => slide.clientWidth > 0);
    this.slideCount = slides.length;
    this.origin = slides.length ? slides[0].offsetLeft : 0;
    this.step = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : 0;
    this.index = -1;
    this.sync();
  }

  onScroll() {
    this.sync();
  }

  sync() {
    if (!this.step) return;
    const index = Math.min(Math.max(Math.round((this.slider.scrollLeft - this.origin) / this.step), 0), this.slideCount - 1);
    if (index === this.index) return;
    this.index = index;

    if (this.currentElement) this.currentElement.textContent = index + 1;
    this.dots.forEach((dot, position) => {
      dot.hidden = position >= this.slideCount;
      dot.classList.toggle('is-active', position === index);
    });
  }

  goTo(index) {
    if (!this.step) return;
    this.slider.scrollTo({ left: this.origin + index * this.step, behavior: 'smooth' });
  }
}

customElements.define('pbx-gallery-nav', PbxGalleryNav);
